<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'resourceManagement-research-fabricPurchase',
  components: {
    PageTable,
  },
}
</script>
